import * as React from 'react';

type PasswordVisibilityButtonProps = {
  show: boolean;
  onClick: () => void;
};

function PasswordVisibilityButton({ show, onClick }: PasswordVisibilityButtonProps) {
  const ariaLabel = show ? 'Hide password' : 'Show password';
  return (
    <button
      type="button"
      className="
        absolute top-1/2 right-3 shrink-0 -translate-y-1/2 text-[#353648]
      "
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {show ? (
          <React.Fragment>
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
            <circle cx="12" cy="12" r="3" />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
            <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
            <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
            <line x1="2" x2="22" y1="2" y2="22" />
          </React.Fragment>
        )}
      </svg>
    </button>
  );
}

export { PasswordVisibilityButton };
